import React, {useEffect, useState} from "react"
import {useHistory} from 'react-router-dom'
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import env from "../config/env"
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
//---
import allTheActions from '../actions'
import TitleH1 from "../components/titleH1"
import HorizontalAlign from "../components/horizontalAlign"
import DivWhite from "../components/divWhite"
import TitleH2 from "../components/titleH2"
import Table from "../components/table"
import Button from "../components/button"
import VerticalAlign from "../components/verticalAlign";
/*import Input from "../components/input"
import * as XLSX from 'xlsx'

const convertDate = (date) => {
    const res = date.split("/")
    return res[2] + "-" + res[1] + "-" + res[0]
}*/

const Dashboard = props => {
    const [clubs, setClubs] = useState([])
    const [licences, setLicences] = useState([])
    const history = useHistory()
    //const [infosUser, setInfos] = useState({})


    useEffect(() => {
        const fetchClubs = async () => {
            const data = await props.actions.club.getAllClubs()
            setClubs(data.clubs)
        }
        fetchClubs()
    }, [props.actions.club])

    useEffect(() => {
        const fetchClubs = async () => {
            setLicences(await props.actions.licence.getAllLicences())
        }
        fetchClubs()
    }, [props.actions.licence])

    /*useEffect(() => {
        const getInfos = async () => {
            setInfos(await JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).login))
        }
        getInfos()
    }, [])*/

    const exportLicences = async () => {
        await props.actions.licence.exportLicences().then((res) => {
            window.open(env.API + res, '_blank');
        })
    }

    const exportClubs = async () => {
        await props.actions.club.exportClubs().then((res) => {
            window.open(env.API + res, '_blank');
        })
    }

    return (
        <>
            <Navbar/>
            <Menu/>
            <TitleH1 content="Vue générale"/>
            <HorizontalAlign content={
                <>
                    <DivWhite content={
                        <VerticalAlign>
                            <div>
                                <TitleH2 content={licences.length} marginLeft="auto" marginRight="auto"
                                         textAlign="center"/>
                                <TitleH2 content="LICENCES" marginLeft="auto" marginRight="auto"
                                         textAlign="center"/>
                            </div>
                            {
                                licences.length > 0 ?
                                    <>
                                        <Table content={
                                            <>
                                                <tbody>
                                                <tr onClick={() => history.push('/expired')}>
                                                    <td>Expirée(s)</td>
                                                    <td>{(licences.filter(licence => new Date(licence.validite) < new Date(`${new Date().getFullYear()}-01-01`))).length}</td>
                                                </tr>
                                                <tr onClick={() => history.push('/licences-solo')}>
                                                    <td>Individuelle(s)</td>
                                                    <td>{(licences.filter(licence => licence.idClub === 'none')).length}</td>
                                                </tr>
                                                </tbody>
                                            </>
                                        } width="100%"/>
                                        {/*<Input type="file" name="file" onChange={handleChangeFile}/>*/}
                                        <Button value="Exporter" width="100%" onClick={exportLicences}/>
                                    </>
                                    : null
                            }
                        </VerticalAlign>
                    } width="49%" margin="25px 0 0 0"/>
                    <DivWhite content={
                        <>
                            <TitleH2 content={clubs.length} marginLeft="auto" marginRight="auto"
                                     textAlign="center"/>
                            <TitleH2 content="CLUBS" marginLeft="auto" marginRight="auto" textAlign="center"/>
                            {
                                clubs.length > 0 ?
                                    <>
                                        <Table content={
                                            <>
                                                <tbody>
                                                <tr>
                                                    <td>Affiliés</td>
                                                    <td>{(clubs.filter(club => club.affiliation === true)).length}</td>
                                                </tr>
                                                <tr>
                                                    <td>Non affiliés</td>
                                                    <td>{(clubs.filter(club => club.affiliation === false)).length}</td>
                                                </tr>
                                                <tr>
                                                    <td>Expirée(s)</td>
                                                    <td>{(clubs.filter(club => new Date(club.validite) < new Date(`${new Date().getFullYear()}-01-01`))).length}</td>
                                                </tr>
                                                </tbody>
                                            </>
                                        } width="100%" cursor="unset"/>
                                        <Button value="Exporter" width="100%" onClick={exportClubs}/>
                                    </>
                                    : null
                            }
                        </>
                    } width="49%" margin="25px 0 0 0"/>
                </>
            } width="100%" padding="15px" margin="25px 0 0 0"/>

        </>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
